"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const knowledge_central_entity_1 = require("../../../../service-lib/src/lib/entities/knowledge-central.entity");
const knowledge_service_1 = require("./knowledge.service");
const knowledge_repository_1 = require("./knowledge.repository");
const knowledge_controller_1 = require("./knowledge.controller");
const jwt_1 = require("@nestjs/jwt");
let KnowledgeModule = class KnowledgeModule {
};
exports.KnowledgeModule = KnowledgeModule;
exports.KnowledgeModule = KnowledgeModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [typeorm_1.TypeOrmModule.forFeature([knowledge_central_entity_1.KnowledgeCentral])],
        controllers: [knowledge_controller_1.KnowledgeController],
        providers: [knowledge_service_1.KnowledgeService, knowledge_repository_1.KnowledgeRepository, jwt_1.JwtService],
    })
], KnowledgeModule);
